import { UNBLOCK_WS, UNBLOCK_WS_SUCCESS, UNBLOCK_WS_ERROR} from './actionTypes';

const initialState = {
    errorBlockWs: "",
    loadingBlockWs: false,
    successBlockWs: ""
}

const blockWorkstations = (state = initialState, action) => {
    switch (action.type) {
        case UNBLOCK_WS:
            state = {
                ...state,
                loadingBlockWs: true
            }
            break;
        case UNBLOCK_WS_SUCCESS:
            state = {
                ...state,
                loadingBlockWs: false,
                successBlockWs: action.payload.message
            }
            break;
        case UNBLOCK_WS_ERROR:
            state = { ...state, errorBlockWs: action.payload, loadingBlockWs: false };
            break;
        default:
            state = { ...state };
            break;
    }
    return state;
}

export default blockWorkstations;